module.exports = __webpack_public_path__ + "static/media/kevin.eb38eec2.jpeg";